/**
 * The three windows the screen offers, mirroring `design/screens/outreach.html#packs`.
 *
 * The API takes any value from 1 to 720 hours (`ck_discovery_settings_age_within_bounds`)
 * and this list is the screen's opinion rather than the server's limit — a tenant
 * whose stored window is none of the three still sees it, via `windowOptions`
 * below, instead of silently having it rewritten to 24 hours by a `<select>` that
 * could not represent it.
 */
const WINDOWS: { hours: number; label: string }[] = [
  { hours: 24, label: '24 hours — freshest, fewest results' },
  { hours: 72, label: '3 days' },
  { hours: 168, label: '7 days' },
]

export function windowOptions(current: number): { hours: number; label: string }[] {
  if (WINDOWS.some((option) => option.hours === current)) return WINDOWS
  return [...WINDOWS, { hours: current, label: `${String(current)} hours` }].sort(
    (a, b) => a.hours - b.hours,
  )
}
